import React, { FC } from 'react';
import Tooltip from '~/src/components/form-components/tooltip/tooltip';
import { getSplitProductName } from '~/src/helpers/get-split-product-name';
import { ATTR_NAMES_LEAD } from '~/src/models/constants/attr-names-lead.constants';
import * as Styled from '~/src/components/blocks/referral-products/products/components/product-list/product-list.styles';

interface ProductProps {
    code: string;
    name: string;
    content: string;
    tooltipIsHovered: boolean;
    onChange: (isChecked: boolean) => void;
    onMouseOverTooltip: () => void;
    checkedOnStart: boolean;
    disabled: boolean;
}

export const Product: FC<ProductProps> = ({
    code,
    name,
    content,
    onChange,
    onMouseOverTooltip,
    tooltipIsHovered,
    checkedOnStart,
    disabled,
}) => {
    const { nameWithoutLastWord, lastWord } = getSplitProductName(name);

    return (
        <Styled.CheckboxWrap
            name={ATTR_NAMES_LEAD.mtsProductCodes + `${code}`}
            withTooltip
            disabled={disabled}
            LabelComponent={
                <Styled.LabelComponent>
                    <Styled.LabelTextOuter>{nameWithoutLastWord}</Styled.LabelTextOuter>
                    <Styled.TooltipContainer>
                        <Styled.LastWordProductName>{lastWord}</Styled.LastWordProductName>
                        {content && (
                            <Tooltip
                                width={300}
                                hintText={content}
                                isHover={tooltipIsHovered}
                                onMouseOver={onMouseOverTooltip}
                                isControlled={true}
                            />
                        )}
                    </Styled.TooltipContainer>
                </Styled.LabelComponent>
            }
            checked={checkedOnStart}
            onChange={onChange}
        />
    );
};
